import { getStorageKey } from '../redux/storage';
import settings from '../../settings';

export const getResumeToken = getStorageKey(
  `${settings.public.wsEndpoint}__login_token__`,
);
